import axios from 'axios'
import changewatcher from '~/lib/changewatcher'

export default {
  data () {
    return {
      currDeliveryMethods: [],
      commissions: [],
      messages: [],
      origSettings: null,
      localSettings: null,
      reloadSettingsOnVersionChange: true
    }
  },
  mixins: [changewatcher],
  computed: {
    versions: {
      get () {
        if (!this.settings || !this.settings.versions) {
          return []
        }
        return this.settings.versions.split(';')
      },
      set (newValue) {
        this.settings.versions = newValue.join(';')
      }
    },
    storefrontversions: {
      get () {
        if (!this.settings || !this.settings.storefrontversions) {
          return []
        }
        return this.settings.storefrontversions.split(';')
      },
      set (newValue) {
        this.settings.storefrontversions = newValue.join(';')
      }
    },
    settings: {
      get () {
        return this.localSettings ? this.localSettings : this.shopSettings(this.shopId)
      },
      set (newValue) {
        this.localSettings = newValue
      }
    },
    settingsLocale: {
      get () {
        if (this.customLocale) {
          return this.customLocale
        }
        if (this.settings && this.settings.locale) {
          return this.settings.locale
        }
        return this.locale
      },
      set (newValue) {
        this.customLocale = newValue
      }
    }
  },
  methods: {
    loadSettings () {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/settings.json?counters=true&pricetiers=true&files=true&alltags=true&apikey=' + this.apiKey + this.versionStr)
        } catch (e) {
          this.showError(e)
          this.loading = false
          reject()
          return
        }
        this.loading = false
        resolve(response.data)
      })
    },
    loadVersionedSettings () {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let settings
        try {
          settings = await this.loadSettings()
          const loaders = []
          loaders.push(this.loadCommissions())
          loaders.push(this.loadDeliveryMethods())
          await Promise.allSettled(loaders)
        } catch(e) {
          this.loading = false
          reject(e)
          return
        }
        this.loading = false
        resolve(settings)
      })
    },
    loadDeliveryMethods () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/settings/1/deliverymethods.json?apikey=' + this.apiKey + this.versionStr)
        } catch(e) {
          this.showError(this._('Error loading delivery methods! Please try again.'))
          resolve([])
          return
        }
        this.currDeliveryMethods = response.data
        resolve(this.currDeliveryMethods)
      })
    },
    loadMessages () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/messages.json?apikey=' + this.apiKey + this.versionStr)
        } catch(e) {
          this.showError(this._('Error loading messages! Please try again.'))
          resolve([])
          return
        }
        this.messages = response.data
        resolve(this.messages)
      })
    },
    loadCommissions () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/commissions.json?apikey=' + this.apiKey + this.versionStr)
        } catch(e) {
          resolve([])
          return
        }
        this.commissions = response.data
        resolve(this.commissions)
      })
    },
    getSaveData () {
      const exportFields = [
        'analyticsapikey',
        'background_id',
        'billCounter',
        'calendarauthcode',
        'currency',
        'defaultversion',
        'googlemapsapikey',
        'gtmkey',
        'hotellinx_password',
        'hotellinx_url',
        'hotellinx_username',
        'igloohome_apikey',
        'ratna_url',
        'ratna_username',
        'ratna_password',
        'ratna_apartments',
        'interest',
        'myallocator_token',
        'myallocator_userid',
        'myallocator_password',
        'netvisor_customerid',
        'netvisor_organizationid',
        'netvisor_userkey',
        'briox_accountid',
        'briox_apptoken',
        'pay_option20',
        'pay_option20_brioxpaymentmethod',
        'pay_option2_brioxpaymentmethod',
        'pay_option3_brioxpaymentmethod',
        'pay_option5_brioxpaymentmethod',
        'pay_option6_brioxpaymentmethod',
        'pay_option7_brioxpaymentmethod',
        'pay_option8_brioxpaymentmethod',
        'pay_option9_brioxpaymentmethod',
        'pay_option10_brioxpaymentmethod',
        'pay_option12_brioxpaymentmethod',
        'pay_option15_brioxpaymentmethod',
        'pay_option16_brioxpaymentmethod',
        'pay_option17_brioxpaymentmethod',
        'pay_option18_brioxpaymentmethod',
        'pay_option19_brioxpaymentmethod',
        'pay_optioncard_brioxpaymentmethod',
        'pay_optioncash_brioxpaymentmethod',
        'pay_optiongiftcard_brioxpaymentmethod',
        'pay_optionvoucher_brioxpaymentmethod',
        'pay_optionbokun_brioxpaymentmethod',
        'pay_optiongyg_brioxpaymentmethod',
        'nocfo_token',
        'nocfo_business_slug',
        'nocfo_base_url',
        'pay_option21',
        'pay_option21_nocfoaccount',
        'pay_option2_nocfoaccount',
        'pay_option3_nocfoaccount',
        'pay_option5_nocfoaccount',
        'pay_option6_nocfoaccount',
        'pay_option7_nocfoaccount',
        'pay_option8_nocfoaccount',
        'pay_option9_nocfoaccount',
        'pay_option10_nocfoaccount',
        'pay_option12_nocfoaccount',
        'pay_option15_nocfoaccount',
        'pay_option16_nocfoaccount',
        'pay_option17_nocfoaccount',
        'pay_option18_nocfoaccount',
        'pay_option19_nocfoaccount',
        'pay_optioncard_nocfoaccount',
        'pay_optioncash_nocfoaccount',
        'pay_optiongiftcard_nocfoaccount',
        'pay_optionvoucher_nocfoaccount',
        'pay_optionbokun_nocfoaccount',
        'pay_optiongyg_nocfoaccount',
        'orderCounter',
        'ownPricetier',
        'default_pricing_engine',
        'pos_session_idle_days',
        'pay_option1',
        'pay_option1_bank',
        'pay_option1_bic',
        'pay_option1_duedays',
        'pay_option1_extraeur',
        'pay_option1_extraperc',
        'pay_option1_iban',
        'pay_option1_noticedays',
        'pay_option1_title',
        'pay_option2',
        'pay_option2_bank',
        'pay_option2_bic',
        'pay_option2_extraeur',
        'pay_option2_extraperc',
        'pay_option2_iban',
        'pay_option2_netvisoraccount',
        'pay_option2_title',
        'pay_option3',
        'pay_option3_extraeur',
        'pay_option3_extraperc',
        'pay_option3_mode',
        'pay_option3_netvisoraccount',
        'pay_option3_pwd',
        'pay_option3_signature',
        'pay_option3_user',
        'pay_option4',
        'pay_option4_extraeur',
        'pay_option4_extraperc',
        'pay_option4_mode',
        'pay_option4_pwd',
        'pay_option4_signature',
        'pay_option4_user',
        'pay_option5',
        'pay_option5_extraeur',
        'pay_option5_extraperc',
        'pay_option5_merchantcode',
        'pay_option5_merchantid',
        'pay_option5_netvisoraccount',
        'pay_option5_title',
        'pay_option6',
        'pay_option6_extraeur',
        'pay_option6_extraperc',
        'pay_option6_merchantcode',
        'pay_option6_merchantid',
        'pay_option6_netvisoraccount',
        'pay_option6_title',
        'pay_option7',
        'pay_option7_extraeur',
        'pay_option7_extraperc',
        'pay_option7_netvisoraccount',
        'pay_option7_trustapikey',
        'pay_option7_trustid',
        'pay_option7_trustservicecode',
        'pay_option8',
        'pay_option8_extraeur',
        'pay_option8_extraperc',
        'pay_option8_netvisoraccount',
        'pay_option8_publishablekey',
        'pay_option8_secretkey',
        'pay_option8_signingsecret',
        'pay_option8_title',
        'pay_option9',
        'pay_option9_apikey',
        'pay_option9_extraeur',
        'pay_option9_extraperc',
        'pay_option9_netvisoraccount',
        'pay_option9_privatekey',
        'pay_option9_title',
        'pay_option10',
        'pay_option10_extraeur',
        'pay_option10_extraperc',
        'pay_option10_merchantid',
        'pay_option10_merchanttoken',
        'pay_option10_netvisoraccount',
        'pay_option10_title',
        'pay_option11',
        'pay_option11_action',
        'pay_option11_description',
        'pay_option11_title',
        'pay_option12',
        'pay_option12_extraeur',
        'pay_option12_extraperc',
        'pay_option12_netvisoraccount',
        'pay_option12_publishablekey',
        'pay_option12_secretkey',
        'pay_option12_signingsecret',
        'pay_option12_title',
        'pay_option13',
        'pay_option13_extraeur',
        'pay_option13_extraperc',
        'pay_option13_netvisoraccount',
        'pay_option15',
        'pay_option15_extraeur',
        'pay_option15_extraperc',
        'pay_option15_netvisoraccount',
        'pay_option15_title',
        'pay_option15_siteid',
        'pay_option15_mac',
        'pay_option16',
        'pay_option16_title',
        'pay_option16_netvisoraccount',
        'pay_option17',
        'pay_option17_extraeur',
        'pay_option17_extraperc',
        'pay_option17_netvisoraccount',
        'pay_option17_title',
        'pay_option17_apitoken',
        'pay_option17_merchantid',
        'pay_option17_loyalty',
        'pay_option18',
        'pay_option18_title',
        'pay_option18_button',
        'pay_option18_branding',
        'pay_option18_netvisoraccount',
        'pay_option19',
        'pay_option19_title',
        'pay_option19_merchantid',
        'pay_option19_extraeur',
        'pay_option19_extraperc',
        'pay_option19_netvisoraccount',
        'pay_optioncard_netvisoraccount',
        'pay_optioncash_netvisoraccount',
        'pay_optiongiftcard_netvisoraccount',
        'pay_optionvoucher_netvisoraccount',
        'pay_optionbokun_netvisoraccount',
        'pay_optiongyg_netvisoraccount',
        'pay_optionvirtualcard_netvisoraccount',
        'profile_facebook',
        'profile_google',
        'profile_linkedin',
        'profile_twitter',
        'send_aftersales_delay',
        'type',
        'vats',
        'channel_channex',
        'channel_gofinland',
        'channel_hotellinx',
        'channel_myallocator',
        'channel_retkipaikka',
        'disablebasket',
        'mark_processed',
        'send_aftersales',
        'orderrequest_cancellation',
        'orderrequest_move',
        'dataservice',
        'statisticsusername',
        'statisticspassword',
        'statisticsidentifier',
        'dateformat',
        'timeformat',
        'numberformat',
        'channel_bokun',
        'bokun_accesskey',
        'bokun_secretkey',
        'bokun_push',
        'channel_gyg',
        'customertype'
      ]
      return exportFields.reduce((a, e) => (a[e] = this.settings[e], a), {})
    }
  },
  watch: {
    async version () {
      if (!this.reloadSettingsOnVersionChange) {
        return
      }
      const settings = await this.loadVersionedSettings()
      this.origSettings = Object.assign({}, settings)
      this.localSettings = Object.assign({}, settings)
      this.storeState()
    }
  }
}